// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Qr-z","imageAndVideoCount":"Rr-z","imageAndVideoContainer":"Sr-z","viewAllReviews":"Tr-z"};